var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoDownloaderDownload = function SvgIconVideoDownloaderDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_video_downloader_download_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.751 11.168a1.56 1.56 0 0 0-2.2 0l-3.494 3.493V2.055a1.559 1.559 0 0 0-3.115 0v12.522l-3.493-3.494a1.56 1.56 0 0 0-2.201 0 1.56 1.56 0 0 0 0 2.202l6.19 6.196c.304.303.701.457 1.104.457a1.57 1.57 0 0 0 1.103-.457l6.111-6.112a1.555 1.555 0 0 0-.005-2.201"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_video_downloader_download_svg__b",
    width: 25,
    height: 4,
    x: 0,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 22.566h25v2.77H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_video_downloader_download_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.608 22.578H1.393c-.765 0-1.381.616-1.381 1.381 0 .766.616 1.382 1.381 1.382h22.215a1.381 1.381 0 0 0 0-2.763"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_video_downloader_download_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h25v25H0z"
  })))));
};
export default SvgIconVideoDownloaderDownload;